import classNames from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import Heading from 'shared/components/common/heading/Heading';
import { logoSite, Printer } from 'assets';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useReactToPrint } from 'react-to-print';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

export default function LayoutIT() {
    const componentRef = useRef(null);
    const location = useLocation();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const [dataIT, setDataIT] = useState(location.state.data);
    const [address, setAddress] = useState('Shop # 54,Ground Floor,Century Tower,Main Link Road.');
    const [city, setCity] = useState('Lahore, Punjab');
    const [postal, setPostal] = useState('54000');
    const [email, setEmail] = useState('Techbizzksa@gmail.com');

    useEffect(() => {
        if (location.state.data) {
            setDataIT(location.state.data);
        }
    }, [location.state.data]);

    return (
        <div className={classNames(styles.mainpoLyout)}>
            <div className={classNames(styles.butoonprint)}>
                <CustomButton Icon={Printer} submitHandle={() => handlePrint()} IconStyle={classNames('me-1', styles.IconStyle)} text={'Print'} containerStyle={classNames(styles.AddProduct)} />
            </div>
            <div ref={componentRef} className={classNames(styles.UserContainer)}>
                <div className={classNames(styles.ourdress, styles.totalsPo)}>
                    <div className={classNames(styles.cusFlex)}>
                        <h4><img src={logoSite} alt="logo" />Wise Tech</h4>
                        <div className={styles.printLabelGroup}>
                            <label>Address:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Address"
                            />
                            <span className={styles.printOnlyShow}>{address}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>City/State:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="City/State"
                            />
                            <span className={styles.printOnlyShow}>{city}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>Postal Code:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={postal}
                                onChange={(e) => setPostal(e.target.value)}
                                placeholder="Postal Code"
                            />
                            <span className={styles.printOnlyShow}>{postal}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>Email:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email Address"
                            />
                            <span className={styles.printOnlyShow}>{email}</span>
                        </div>
                    </div>
                    <Heading heading={'Internal Transfer Note'} headingStyle={styles.Heading} />
                </div>
                <div className={classNames(styles.billingToPo)}>
                    <div className={classNames(styles.billto, styles.cusFlex)}>
                        <h6>Transfer Details</h6>
                        <label><strong>Source Warehouse:</strong> {dataIT.fromWarehouse?.code || '-'}</label>
                        <label><strong>Destination Warehouse:</strong> {dataIT.toWarehouse?.code || '-'}</label>
                    </div>
                    <div className={classNames(styles.billto)}>
                        <h6>IT#: {dataIT?.order_number || dataIT?.transfer_number || 'IT-' + dataIT?._id?.slice(-6).toUpperCase()}</h6>
                        <div className="d-flex align-items-center">
                            <h6 className="mb-0">Date:</h6>
                            <span className="ps-2">{moment(dataIT?.created_at).format('DD, MMM YYYY')}</span>
                        </div>
                        {dataIT?.transferPerson && (
                            <div className="d-flex align-items-center mt-1">
                                <h6 className="mb-0">Transferred By:</h6>
                                <span className="ps-2">{dataIT.transferPerson}</span>
                            </div>
                        )}
                        {dataIT?.referenceNumber && (
                            <div className="d-flex align-items-center mt-1">
                                <h6 className="mb-0">Ref#:</h6>
                                <span className="ps-2">{dataIT.referenceNumber}</span>
                            </div>
                        )}
                    </div>
                </div>
                <div className={classNames(styles.poItems)}>
                    <table border="0" className={classNames(styles.cusTable)}>
                        <thead>
                            <tr>
                                <th style={{ width: '60%' }}>Description / SKU</th>
                                <th style={{ width: '40%' }}>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataIT?.items?.map((Item, inx) => (
                                <tr key={inx}>
                                    <td>
                                        <strong>{Item.sku}</strong>
                                        {Item.product && <div>{Item.product.name}</div>}
                                    </td>
                                    <td>{Item.quantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {dataIT.description && (
                    <div className="mt-4 p-3 border rounded" style={{ background: '#f8f9fa' }}>
                        <h6>Comments:</h6>
                        <p className="mb-0">{dataIT.description}</p>
                    </div>
                )}

                <div className={classNames(styles.reference)}>
                    <div className={classNames(styles.linkSite)}>
                        <a href="/">wisetech.com</a>
                    </div>
                    <div className={classNames(styles.logo)}>
                        <img src={logoSite} alt="logo" />
                    </div>
                </div>
            </div>
        </div>
    );
}
